import { ChangeEvent, useState } from "react";
import { Stack, TextField, Container, Typography, Grid, Card } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { toast } from "react-toastify";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";

import { API_URL } from "Constants";

interface IInput {
  name: string;
  label: string;
  type?: string;
  grid?: number;
}

const INPUTS: IInput[] = [{ name: "email", label: "ایمیل" }];

export default function ForgotPassword() {
  const [formData, setFormData] = useState<{ [key: string]: any }>({});
  const [requesting, setRequesting] = useState<boolean>(false);
  const [isRobot, setIsRobot] = useState<boolean>(true);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleSubmit = () => {
    if (isRobot) {
      toast.error("من ربات نیستم را تایید کنید");
      return;
    }
    setRequesting(true);
    axios.post(`${API_URL}/forgot`, formData).then((res) => {
      toast.success("ایمیل برای شما ارسال شد");
      setRequesting(false);
    });
  };
  const handleReCAPTCHA = (value: any) => {
    setIsRobot(false);
  };

  const renderInputs = () => {
    return INPUTS.map((input) => (
      <Grid item xs={12} md={input.grid || 12}>
        <Stack spacing={1}>
          <Typography>{input.label}</Typography>
          <Card>
            <TextField
              type={input.type}
              name={input.name}
              variant="filled"
              fullWidth
              sx={{ "& input": { height: "30px" } }}
              onChange={handleInputChange}
            />
          </Card>
        </Stack>
      </Grid>
    ));
  };

  return (
    <Container maxWidth="xs">
      <Grid container rowGap={3} columnSpacing={2}>
        {renderInputs()}

        <Grid item xs={12} sx={{ display: "grid", placeItems: "center" }}>
          <ReCAPTCHA sitekey="6LctDTskAAAAALxgxoeUw2XXBwUW_GnWDLVyXEpZ" onChange={handleReCAPTCHA} />
        </Grid>

        <Grid item xs={12}>
          <LoadingButton
            loading={requesting}
            variant="contained"
            color="success"
            fullWidth
            size="large"
            sx={{ py: 1.5 }}
            onClick={handleSubmit}
          >
            تایید
          </LoadingButton>
        </Grid>
      </Grid>
    </Container>
  );
}
